export default "__VITE_ASSET__CT4L$LFj__"